import { AnyObject } from '@vimeo/core/types/generic';

import { getLocalStorageConfigItem } from './local_storage';
import { getUrlQueryObject } from './url_query';
import { environmentConfig } from '../../configs/EnvironmentConfig';

/**
 * Preserve initial query object that contains configuration on page load.
 * On SSR ignore it to prevent any issues with pre-rendering.
 */
const initialQueryObject: AnyObject = environmentConfig.IS_SSR ? {} : getUrlQueryObject();

/**
 * Get live configuration value.
 *   - Get overriding values from query params
 *   - Get values from local storage
 *   - Fallback to default value
 *
 * todo: Rename to make reusable in vimeo core.
 */
export function getLiveConfigValue<T>(
  key: string,
  defaultValue: T,
  source: AnyObject = initialQueryObject,
): T {
  if (key in source) {
    const value: string = source[key];

    /**
     * Try JSON parsing provided value to correctly handle numbers, boolean values and nulls.
     * In case of fail, fallback to 'as is'.
     */
    try {
      return JSON.parse(value);
    } catch (error) {
      return value as unknown as T;
    }
  }

  return getLocalStorageConfigItem(key, defaultValue);
}
